export const Storage = {
  get: (key) => {
    const value = window.localStorage.getItem(key) || null;
    return value;
  },
  set: (key, value) => {
    window.localStorage.setItem(key, value);
  },
  remove: (key) => {
    window.localStorage.removeItem(key);
  }
};

export const handleResponse = (resolve, reject, response) => {
  const status = response.body.status;
  const data = response.body.data;
  const msg = response.body.msg;
  if (status === -1) {
    reject({
      msg: msg
    });
  } else {
    resolve(data);
  }
};


export const getZoom = () => {
  const isWindows = navigator.userAgent.toLowerCase().indexOf('windows') >= 0;
  const zoom = 1 / (window.devicePixelRatio);
  console.log(isWindows ? { zoom } : null);
  return isWindows && zoom < 1 ? zoom : 1;
}


// WEBPACK FOOTER //
// ./src/utils.js